module.exports = __webpack_public_path__ + "static/media/aging-report.bc15f822.svg";